module.exports = __webpack_public_path__ + "assets/diagnosis-menu-pic.da0de429.jpg";